<template>
  <div class="card-content">
    <div id="menu-tab">
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="item in comps" :key="item.name" :name="item.name" :label="$t(item.label)">
        </el-tab-pane>
      </el-tabs>
    </div>
    <keep-alive>
      <component :is="activeName" :externalHeight="tabMenuHeight" @select="handleSelect" @export="handleBatchExport" />
    </keep-alive>
  </div>
</template>

<script>
import PowerSet from "@/components/hardware/PowerSet";
import AutoStart from "@/components/hardware/AutoStart";
import LightSet from "@/components/hardware/LightSet";
import Temperature from "@/components/hardware/Temperature";
import HintSound from "@/components/hardware/HintSound";
import RecipeOperate from "@/components/hardware/RecipeOperate";
import RenewSet from "@/components/hardware/RenewSet";
import PrecisionAdjust from "@/components/hardware/PrecisionAdjust";
import PrecisionSet from "@/components/hardware/PrecisionSet";
import DeviceButton from "@/components/hardware/DeviceButton";
import {request} from "@/config/request";
import {downloadFile} from "@/utils/common";

export default {
  name: "HardwareList",
  components: {
    DeviceButton,
    PrecisionSet,
    PrecisionAdjust, RenewSet, RecipeOperate, HintSound, Temperature, LightSet, AutoStart, PowerSet
  },
  data() {
    return {
      activeName: 'PowerSet',
      comps: [ // 感应重量自动开机、按键提示音
        {name: "PowerSet", label: "开关机设置"},
        {name: "AutoStart", label: "感应重量自动开机"},
        {name: "LightSet", label: "亮屏设置"},
        {name: "Temperature", label: "温度设置"},
        {name: "HintSound", label: "按键提示音"},
        {name: "RecipeOperate", label: "菜谱操作设定"},
        {name: "RenewSet", label: "恢复出厂设置"},
        {name: "PrecisionAdjust", label: "精度调整"},
        {name: "PrecisionSet", label: "精度设置"},
        {name: "DeviceButton", label: "按键功能"},
      ],
      tabMenuHeight: 0,

      exportForm: {}
    }
  },
  mounted() {
    this.handleResizeTableHeight();
  },
  methods: {
    // 批量导出
    async handleBatchExport() {
      try {
      /*  const codes = Object.values(this.exportForm);
        if(!codes.flat().length) {
          this.$message.warning("请选择导出数据");
          return;
        }*/
        const res = await request(this.$api.common.hardwareExport, this.exportForm, {isJson: true});
        downloadFile(res.excelUrl);
      } catch (e) {
        console.log(e);
      }
    },

    handleSelect(obj) {
      for (const key in obj) {
        this.exportForm[key] = obj[key];
      }
    },

    // 监听表格内容高度
    handleResizeTableHeight() {
      this.$nextTick(() => {
        const wrapper = document.querySelector("#menu-tab");
        this.tabMenuHeight = (wrapper?.clientHeight || 0) + 40;
      })
    },
  }
}
</script>

<style scoped>

.card-content {
  background: #ffffff;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 12px;
}

</style>
